import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../Icon';
import ArchivedToggle from '../ui/ArchivedToggle';
import ExportButton from './ExportButton';
import { useRole } from '../../hooks/useRole';

interface VenuesListBarProps {
  archived: boolean;
  onArchivedChange: (archived: boolean) => void;
}

/** Breadcrumb actions of the Venues list: Archived switch, New, icon Export. */
export const VenuesListBar: React.FC<VenuesListBarProps> = ({ archived, onArchivedChange }) => {
  const navigate = useNavigate();
  const { canEdit } = useRole();
  return (
    <>
      <div className="header-filter-group">
        <ArchivedToggle checked={archived} onChange={onArchivedChange} />
      </div>
      {canEdit && (
        <button type="button" className="header-action-btn header-action-btn--iconic primary" onClick={() => navigate('/venue/new')} title="New Venue">
          <Icon name="plus" size={16} />
          <span className="header-action-btn__label">New Venue</span>
        </button>
      )}
      <ExportButton exportKey="venues" />
    </>
  );
};

export default VenuesListBar;
